<select #comboBox
  [(ngModel)]="selectedSmallClassCode" [disabled]="disabled" [hidden]="!visible"
  (change)="update($event);onChange($any($event.target).value);" (blur)="onTouched()"
  [style.width.px]="width" [style.width]="width !== undefined ? width : '100%'"
  [tabindex]=" tabindex" [class.combo-box-required]="required">
  <ng-template ngFor let-item [ngForOf]="model.smallClassList">
    <option value="{{item.SmallClassCode}}">{{item.SmallClassCodeName}}</option>
  </ng-template>
</select>
